JST["home-trial-size-info"] = function anonymous(it
) {
var out='<li class="home-trial__item size-info mb-1"> <div class="info-box warning compact"> '+( texts('homeTrialSizeInfo@homeTrial') )+' <a class="link-2 bold" href="'+( texts('homeTrialLink@homeTrial') )+'"> '+( texts('readMore@glasses') )+' </a> </div></li>';return out;
};